import { AuthObject } from './objects';
import { ChannelObject } from './objects';
import { EpgObject } from './objects';
import { InitObject } from './objects';
import { RequestParams } from './objects';
import $ from 'jquery';

export function checkNumber(arg) {
    return typeof arg === "number";
}

export function checkString(arg) {
    return typeof arg === "string";
}

export function checkFunc(arg) {
    return typeof arg === "function";
}

export function checkArray(arg) {
    return Array.isArray(arg);
}

export function checkObject(arg) {
    return typeof arg === "object";
}

export function checkInstance(obj, arg) {
    return arg instanceof obj;
}

export function checkObjectOrUndefined(arg) {
    return (arg === undefined || typeof arg === "object");
}

export function checkStringOrNumber(arg) {
    if (typeof arg === "string" || typeof arg === "number") {
        return true;
    }
    return false;
}

export function checkStringOrObject(arg) {
    if (typeof arg === "string" || typeof arg === "object") {
        return true;
    }
    return false;
}

export function checkStringOrUndefined(arg) {
    if (typeof arg === "string" || arg === undefined) {
        return true;
    }
    return false;
}

export function checkRest(arg) {
    return ["GET", "POST", "PUT", "DELETE"].indexOf(arg) >= 0;
}

export function typeCheck(func, checks, canBeLess) {
    return function () {
        if (checks.length < arguments.length) {
            getlog("Функция " + func.name + " получает больше аргументов, чем выставлено проверок!");
        }
        for (let i = 0; i < arguments.length; i++) {
            if (!checks[i]) {
                getlog("Для этого аргумента проверка не выставлена. Аргумент:");
                getlog(arguments[i]);
                mistakes.push([func.name, arguments[i]]);
            } else if (!checks[i](arguments[i])) {
                getlog(func.name + ": Аргумент некорректный");
                getlog(arguments[i]);
                mistakes.push([func.name, arguments[i]]);
                return false;
            }
        }
        return func.apply(this, arguments);
    };
}

export function getlog(s) {
    console.log(s);
}

let isAuthObject = checkInstance.bind(null, AuthObject);
export let isChannelObject = checkInstance.bind(null, ChannelObject);
let isEpgObject = checkInstance.bind(null, EpgObject);
let isInitObject = checkInstance.bind(null, InitObject);
let isRequestParams = checkInstance.bind(null, RequestParams);
let isJQueryObject = checkInstance.bind(null, $);
let isEvent = checkInstance.bind(null, Event);

let mistakes = [];



// WEBPACK FOOTER //
// ./src/api/type_checker.js